import { render, staticRenderFns } from "./select.vue?vue&type=template&id=6bc90c80&scoped=true"
import script from "./select.vue?vue&type=script&lang=js"
export * from "./select.vue?vue&type=script&lang=js"
import style0 from "./select.vue?vue&type=style&index=0&id=6bc90c80&prod&scoped=true&lang=scss"
import style1 from "./select.vue?vue&type=style&index=1&id=6bc90c80&prod&scoped=true&lang=scss"
import style2 from "./select.vue?vue&type=style&index=2&id=6bc90c80&prod&scoped=true&lang=scss"
import style3 from "./select.vue?vue&type=style&index=3&id=6bc90c80&prod&scoped=true&lang=scss"
import style4 from "./select.vue?vue&type=style&index=4&id=6bc90c80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc90c80",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default})
